module.exports = " <div> <div class=click-block :class=\"{'click-block-hide': !inAnimation}\"></div> <div class=modal-backdrop :class=\"{'active': active, 'hide': !active}\"> <div class=modal-backdrop-bg style=\"position: fixed\"></div> <div class=modal-wrapper von-modal-wrapper> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/Modal.vue
// module id = 238
// module chunks = 0